import axios from "axios";

const api = axios.create({
    //baseURL: 'http://localhost:3333',
    baseURL: process.env.REACT_APP_API_URL || 'https://api.h7trainning.com',
});


export default api;